import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';

import { Observable, filter, take } from 'rxjs';

import { AuthService, OrganisationService } from '@core/services';

@Injectable({
    providedIn: 'root',
})
export class DashboardGuard {
    constructor(private authService: AuthService, private organisationService: OrganisationService, private router: Router) {}

    canMatch(_route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
        return new Observable<boolean | UrlTree>((obs) => {
            if (this.authService.isAccessTokenExpired()) {
                this.authService.setLoginRedirect('/dashboard/' + segments.join('/'));
                obs.next(this.router.createUrlTree(['/login']));
                return;
            }

            this.authService.activeUser
                .pipe(
                    filter((user) => user !== undefined),
                    take(1),
                )
                .subscribe((user) => {
                    const orgId = Number(segments[0].path);
                    if (this.authService.adminMode.getValue() || user!.roles.some((role) => role.organisationId === orgId)) {
                        if (this.organisationService.activeOrganisation.getValue()?.id !== orgId) {
                            this.organisationService.getOrganisation(orgId).subscribe({
                                next: (org) => {
                                    this.organisationService.activeOrganisation.next(org);
                                    obs.next(true);
                                },
                                error: (err) => {
                                    console.error('failed getting the organisation', err);
                                    obs.next(this.router.createUrlTree(['/forbidden']));
                                },
                            });
                        } else {
                            obs.next(true);
                        }
                    } else {
                        obs.next(this.router.createUrlTree(['/forbidden']));
                    }
                });
        });
    }
}
